<template>
	<!-- Page Container -->
	<div class="page-container">
	  <!-- Main -->
	  <main class="main news">
	  	<section id="magazine">
	        <div class="ticker bg-pink loaded" data-title="News">
	            <div>
	            	<marquee-text :duration="60">
	            	  <h3 class="ticker-item fs-normal">News</h3>
	            	  <span class="ticker-item performa fs-normal">Performa</span>
	            	  <span class="ticker-item fs-normal">News</span>
	            	  <span class="ticker-item performa fs-normal">Performa</span>
	            	</marquee-text>
	            </div>
	        </div>
	        
	        
	        <div id="news-articles" class="section-wrap news-wrap">
            <div class="grid-container c3 list-posts">
	            
	            <NewsPost v-for="(item, index) in posts" :key="item.id" :post="item"></NewsPost>
	            
            </div>
	        </div>
	        
	        <div class="section-wrap pagination">
		        
		        
						  <paginate
						    v-model="current_page"
						    :page-count="total_pages"
						    :page-range="3"
						    :margin-pages="2"
						    :click-handler="clickCallback"
						    :prev-text="'⟵'"
						    :next-text="'⟶'"
						    :container-class="'pagination'"
						    :page-class="'page-item'">
						  </paginate>
			
		         
	        </div>
	   </section>     
	  </main>
	</div>

</template>

<script>	
import moment from 'moment'
import Paginate from 'vuejs-paginate'
import NewsPost from '../components/NewsPost.vue'

const toggleClass = function (target, addRemoveClass, className) {
  if (addRemoveClass === 'addClass') {
    target.classList.add(className);
  } else {
    target.classList.remove(className);
  }
}

export default {
  name: 'News',
  components: {
	  NewsPost,
	  Paginate
  },
  metaInfo () {
    return {
      title: this.fields.title
    }
  },
  data () {
    return {
	    today: null,
      fields: {
        title: 'News'
      },
      tag: 'all',
      sort: 'newest',
      total_pages: 0,
      total: null,
      per_page: 12,
      current_page: 1,
      posts: []
    }
  },
  computed: {
  },
	methods: {
		clickCallback (page) {
      console.log(page);
      this.getContent();
    },
	  getContent () {
		  this.$prismic.client.query(
			  this.$prismic.Predicates.at('document.type', 'post'),
			  { orderings : '[my.post.date desc]', pageSize : this.per_page, page : this.current_page }
			).then((response) => {
				this.total_pages = response.total_pages;
				this.total = response.total_results_size;
				this.per_page = response.results_per_page;
				this.current_page = response.page;
			  this.posts = response.results;
			  // console.log(response);
			})
	  }
	},
	created () {
	  this.getContent();
  },
  mounted() {
	  setTimeout(function() {
			toggleClass(document.body, 'addClass', 'loaded');
		}, 500);
  }
}
</script>

<style>
	
</style>